import { Heading, HeadingProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface NavSectionTitleProps extends HeadingProps {
  label: string;
}

export const NavSectionTitle = (props: NavSectionTitleProps) => {
  const { t } = useTranslation();
  const { label, ...HeadingProps } = props;
  return (
    <Heading as="h2" size="xxs" opacity={0.9} {...HeadingProps} m={0}>
      {t(label)}
    </Heading>
  );
};
